import { useEffect, useState } from 'react';

// "controllers"
import { UserController } from 'controllers';

// components
import { Hero } from 'shared/components/bulma/hero';
import { Boxes } from 'shared/components/customers/boxes';
import { Level, LevelItem } from 'shared/components/bulma/level';
import { CustomerComments } from 'shared/components/customers/comments';

import { Goals } from './goals';
import { Profile } from './profile';
import { Feedbacks } from './feedbacks';
import { BodyShape } from './body-shape';
import { Preferences } from './preferences';
import { Lifestyle } from './lifestyle';
import { ProductScan } from './product-scan';
import { SwipeGameView } from './swipe-game';
import { NewSwipeGameView } from './new-swipe-game';
import { CustomerInfo } from './customer-info';
import { InspirationalPhotos } from './inspirational-photos';
import { CustomerRecommendations } from './customer-recommendations';

// pipes
import { titleCasePipe } from 'shared/pipes';
import { Button } from 'shared/components/bulma/button';
import { useHistory } from 'react-router';
// helper
import * as helper from './helper';

const SizeInfo = ({ customer }) => {
    const focusKeys = ['height', 'shirt_size', 'denim_size'];

    return (
        <Level>
            {focusKeys.map((key) => (
                <LevelItem key={key} heading={titleCasePipe.transform(key)} value={customer[key]} />
            ))}
        </Level>
    );
};

const StylistInterface = ({ match }) => {
    const [customer, setCustomer] = useState({});
    const [boxes, setBoxes] = useState([]);
    const [atRisk, setAtRisk] = useState(false);
    const [winBack, setWinBack] = useState(false);

    const history = useHistory();

    useEffect(() => {
        const customerId = match.params.id;

        const getCustomer = async () => {
            const data = await UserController.getUserById(customerId);
            setCustomer(data);

            const boxes = await UserController.getUserBoxes(customerId);
            setBoxes(boxes);

            const atRisk = await helper.isCustomerAtRisk({ customerId, boxes });
            setAtRisk(atRisk);
            const winBack = await helper.isCustomerWinBack(data);
            setWinBack(winBack);
        }

        getCustomer();
    }, [match]);

    const navigateEdit = () => {
        history.push({ pathname: `/closet-hackers/${match.params.id}` });
    }
    if (!customer) {
        return null;
    }
    return (
        <>
            <CustomerRecommendations customer={customer} />

            <Hero className="is-light is-small">
                <div className="container">

                    <CustomerInfo customer={customer} boxes={boxes} atRisk={atRisk} winBack={winBack} />

                    <div className="columns">
                        <div className="column">
                            <SizeInfo customer={customer} />
                        </div>
                    </div>

                    <Feedbacks customer={customer} />
                </div>
            </Hero>

            <Hero className="is-primary">
                <Preferences customer={customer} />
            </Hero>

            <Hero className="is-primary">
                <BodyShape customer={customer} />
            </Hero>

            <Hero className="is-primary">
                <Lifestyle customer={customer} />
            </Hero>

            <Hero>
                <div className="container">
                    <Goals customer={customer} />
                </div>
            </Hero>

            <Hero>
                <div className="container">
                    <Profile customer={customer} />
                </div>
            </Hero>

            <Hero>
                <CustomerComments customer={customer} edit={false} />
            </Hero>

            <Hero className="is-light">
                <div className="container is-fluid">
                    <p className="subtitle">Inspiration Images</p>
                    <InspirationalPhotos id="inspiration-images" customer={customer} />

                    {!!customer.swipe_game?.onboarding && (
                        <>
                            <p className="subtitle mt-6">Accepted Images New Onboarding</p>
                            <NewSwipeGameView id="yes-game" imageIds={customer.swipe_game.onboarding.accepted || []} />

                            <p className="subtitle mt-6">Rejected Images New Onboarding</p>
                            <NewSwipeGameView id="no-game" imageIds={customer.swipe_game.onboarding.rejected || []} />
                        </>
                    )}

                    {/* <>
                        <p className="subtitle mt-6">Accepted Images</p>
                        <SwipeGameView id="yes-game" imageIds={customer.accepted_images || []} />

                        <p className="subtitle mt-6">Rejected Images</p>
                        <SwipeGameView id="no-game" imageIds={customer.rejected_images || []} />
                    </> */}
                    <p className="subtitle mt-6">Accepted Images</p>
                    <SwipeGameView id="yes-game" imageIds={customer.accepted_images || []} />

                    <p className="subtitle mt-6">Rejected Images</p>
                    <SwipeGameView id="no-game" imageIds={customer.rejected_images || []} />
                </div>
            </Hero>

            <Hero className="is-primary">
                <Boxes customer={customer} boxes={boxes} withStatus={false} />
            </Hero>

            <ProductScan customer={customer} />
            <Button onClick={navigateEdit} className="is-white is-afloat-right">
                <span className="icon-text">
                    <span className="icon">
                        <i className="fas fa-edit"></i>
                    </span>
                    <span>Modify &nbsp;</span>
                </span >
            </Button>

            <CustomerRecommendations customer={customer} />

        </>
    );
}

export default StylistInterface;
